/*
 * pv-site.js (fix batch 2026-10-03). Vanilla JS, no libraries, loaded deferred
 * on every page from layout/theme.liquid.
 *
 * 1. LANGUAGE SWITCH. snippets/pv-lang-switch.liquid renders a real link to
 *    the same page in the other language. Liquid cannot see the query string,
 *    so the tap adds it here (a chosen ?variant= survives the switch).
 *
 * 2. WHERE A VISITOR CAME FROM (Anas 2026-10-03: "source carried into
 *    WhatsApp and forms").
 *    - The landing UTM tags, ad click ids and referrer host are kept for the
 *      browser session (sessionStorage, first landing of the session wins).
 *    - A short source code is built from them, e.g. IG, META, GADS, GO, DIR,
 *      plus one letter for the page the tap came from (P piece, K package,
 *      C collection, H home, F Furnish My Space, T contact, O other):
 *      "IG-P". Every WhatsApp link gets one line "Ref: IG-P" at the moment
 *      of the tap, so CX sees where the chat started. Nothing personal is
 *      stored or sent.
 *    - Every Shopify contact form (Furnish My Space, contact page, partners)
 *      gets hidden fields with the code, the UTM tags and the landing page,
 *      so the email the team receives carries them.
 *    - Two custom events are published for the custom pixel (Customer
 *      events): pv_whatsapp_click (GA4 whatsapp_click, Meta Contact) here, and
 *      pv_fms_submit from assets/pv-prp-form.js (GA4 fms_submit, Meta Lead).
 *      Shopify.analytics.publish is the storefront API for custom events.
 */
(function () {
  'use strict';

  if (window.PvSite) return;

  var STORE_KEY = 'pvAttr';
  var PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid', 'ttclid'];

  /* ---------- 1. language switch ---------- */
  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('a[data-pv-lang-switch]') : null;
    if (!link) return;
    var extra = (window.location.search || '') + (window.location.hash || '');
    if (!extra) return;
    try {
      var url = new URL(link.getAttribute('href'), window.location.origin);
      url.search = window.location.search;
      url.hash = window.location.hash;
      link.setAttribute('href', url.pathname + url.search + url.hash);
    } catch (e) {
      /* keep the plain link */
    }
  }, true);

  /* ---------- 2. attribution ---------- */
  function readStore() {
    try {
      return JSON.parse(window.sessionStorage.getItem(STORE_KEY) || 'null');
    } catch (e) {
      return null;
    }
  }

  function writeStore(value) {
    try {
      window.sessionStorage.setItem(STORE_KEY, JSON.stringify(value));
    } catch (e) {
      /* storage blocked: the code is still computed for this page */
    }
  }

  function hostOf(url) {
    try {
      return new URL(url).hostname.replace(/^www\./, '').toLowerCase();
    } catch (e) {
      return '';
    }
  }

  function captureLanding() {
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      params = null;
    }
    var found = {};
    var any = false;
    if (params) {
      PARAMS.forEach(function (key) {
        var value = params.get(key);
        if (value) {
          found[key] = String(value).slice(0, 80);
          any = true;
        }
      });
    }
    var referrer = hostOf(document.referrer || '');
    var ownHost = window.location.hostname.replace(/^www\./, '').toLowerCase();
    if (referrer === ownHost || /myshopify\.com$/.test(referrer) || /(^|\.)povellea\.ae$/.test(referrer)) referrer = '';

    var stored = readStore();
    /* A new campaign landing inside the same session replaces the old one;
       an internal page view never does. */
    if (!stored || any) {
      stored = {
        params: found,
        referrer: stored && !any ? stored.referrer : referrer,
        landing: window.location.pathname,
        at: new Date().toISOString().slice(0, 16)
      };
      writeStore(stored);
    }
    return stored;
  }

  function sourceCode(attr) {
    var p = (attr && attr.params) || {};
    var src = String(p.utm_source || '').toLowerCase();
    var med = String(p.utm_medium || '').toLowerCase();
    var paid = /cpc|ppc|paid|ads?$|display|cpm|social_paid|paidsocial/.test(med);
    if (p.gclid || (src === 'google' && paid)) return 'GADS';
    if (/^(ig|instagram)/.test(src)) return paid || p.fbclid ? 'META' : 'IG';
    if (/^(fb|facebook|meta)/.test(src)) return paid || p.fbclid ? 'META' : 'FB';
    if (p.fbclid) return 'META';
    if (/whatsapp|^wa$/.test(src)) return 'WA';
    if (/mail|newsletter|klaviyo|shopify_email/.test(src) || med === 'email') return 'EM';
    if (/tiktok/.test(src) || p.ttclid) return 'TT';
    if (/partner|referral/.test(src) || med === 'partner') return 'PT';
    if (src) return src.replace(/[^a-z0-9]/g, '').slice(0, 6).toUpperCase() || 'UTM';
    var ref = (attr && attr.referrer) || '';
    if (!ref) return 'DIR';
    if (/(^|\.)google\./.test(ref)) return 'GO';
    if (/(^|\.)bing\.com$|duckduckgo|yahoo\./.test(ref)) return 'SE';
    if (/instagram\.com$/.test(ref)) return 'IG';
    if (/facebook\.com$|fb\.me$/.test(ref)) return 'FB';
    if (/chatgpt|openai|perplexity|gemini\.google|copilot|claude\.ai/.test(ref)) return 'AI';
    if (/whatsapp/.test(ref)) return 'WA';
    return 'REF';
  }

  function pageLetter() {
    var body = document.body ? document.body.className : '';
    if (/template-product-package-builder/.test(body) || document.querySelector('a[data-pv-wa="package"]')) return 'K';
    if (/template-product/.test(body)) return 'P';
    if (/template-collection/.test(body)) return 'C';
    if (/template-index/.test(body)) return 'H';
    if (/template-page-private-room-preview|private-room-preview|furnish-my-space/.test(body + ' ' + window.location.pathname)) return 'F';
    if (/template-page-contact/.test(body) || /\/pages\/contact/.test(window.location.pathname)) return 'T';
    return 'O';
  }

  var attr = captureLanding();
  var code = sourceCode(attr);
  var fullCode = code + '-' + pageLetter();

  function publish(name, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (e) {
      /* analytics must never break the page */
    }
  }

  /* WhatsApp: the Ref line is added at the moment of the tap, after
     pv-whatsapp-context.js has written the current variant into the link. */
  function tagWhatsAppLink(link) {
    var href = link.getAttribute('href') || '';
    if (!/wa\.me\/|api\.whatsapp\.com/.test(href)) return;
    try {
      var url = new URL(href, window.location.origin);
      var text = url.searchParams.get('text') || '';
      if (/(^|\n)Ref: [A-Z0-9]+-[A-Z]$/.test(text)) {
        text = text.replace(/(\n\n)?Ref: [A-Z0-9]+-[A-Z]$/, '');
      }
      text = (text ? text + '\n\n' : '') + 'Ref: ' + fullCode;
      url.searchParams.set('text', text);
      link.setAttribute('href', url.toString());
    } catch (e) {
      /* leave the link as it was */
    }
  }

  function onWhatsAppTap(event) {
    var link = event.target && event.target.closest ? event.target.closest('a[href*="wa.me/"], a[href*="api.whatsapp.com"]') : null;
    if (!link) return;
    tagWhatsAppLink(link);
    if (event.type === 'click') {
      publish('pv_whatsapp_click', {
        source_code: fullCode,
        source: code,
        page_type: pageLetter(),
        page_path: window.location.pathname,
        link_kind: link.getAttribute('data-pv-wa') || (link.id === 'whatsapp-sticky-icon' ? 'floating' : 'link')
      });
    }
  }

  document.addEventListener('pointerdown', onWhatsAppTap, true);
  document.addEventListener('click', onWhatsAppTap, true);

  /* Contact forms: hidden fields, added once per form. */
  function addHidden(form, name, value) {
    if (!value || form.querySelector('input[type="hidden"][name="' + name + '"]')) return;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  function tagForms() {
    var p = (attr && attr.params) || {};
    var forms = document.querySelectorAll('form');
    for (var i = 0; i < forms.length; i++) {
      var type = forms[i].querySelector('input[name="form_type"]');
      if (!type || type.value !== 'contact') continue;
      addHidden(forms[i], 'contact[Source code]', fullCode);
      addHidden(forms[i], 'contact[UTM source]', p.utm_source);
      addHidden(forms[i], 'contact[UTM medium]', p.utm_medium);
      addHidden(forms[i], 'contact[UTM campaign]', p.utm_campaign);
      addHidden(forms[i], 'contact[UTM content]', p.utm_content);
      addHidden(forms[i], 'contact[Ad click]', p.gclid ? 'Google' : (p.fbclid ? 'Meta' : ''));
      addHidden(forms[i], 'contact[Landing page]', attr && attr.landing);
      addHidden(forms[i], 'contact[Referrer]', attr && attr.referrer);
    }
  }

  function ready() {
    tagForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  window.PvSite = {
    sourceCode: function () { return fullCode; },
    attribution: function () { return attr; },
    publish: publish
  };
})();
